module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6a8dc5055578021d14e852d671271d5d.png";